var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 13,
    fill: "#FFBAB3",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6357 39.8317C55.2959 39.8317 55.8327 39.2949 55.8327 38.6347V34.5671C55.8327 28.4538 52.0168 24.6665 45.9416 24.6665H34.0666C27.9533 24.6665 24.166 28.4538 24.166 34.5718V46.4468C24.166 52.5458 27.9533 56.3332 34.0666 56.3332H45.9463C52.0453 56.3332 55.8327 52.5458 55.8279 46.4421C55.8279 45.7739 55.2848 45.2308 54.6167 45.2308C53.9469 45.2308 53.4054 45.7739 53.4054 46.4421C53.4054 51.2459 50.7597 53.9059 45.9416 53.9059H34.0666C29.2485 53.9059 26.5885 51.2459 26.5885 46.4421V34.5671C26.5885 29.749 29.2485 27.089 34.0713 27.089H45.9463C50.766 27.089 53.4102 29.7332 53.4102 34.5671V38.5919V38.5951C53.4118 39.2633 53.9533 39.8032 54.6214 39.8032V39.8317H54.6357ZM36.5394 42.3134L35.4564 43.3964C34.9735 43.8556 34.9466 44.6171 35.3963 45.1096L35.4311 45.1349C35.8934 45.5972 36.6376 45.6099 37.1142 45.1634L38.1924 44.0851C38.6817 43.6291 38.7086 42.8628 38.2526 42.372C37.795 41.8843 37.0287 41.8558 36.5394 42.3134ZM44.9751 44.9384C44.5096 45.4023 43.7575 45.4118 43.281 44.9574L43.2208 44.8988L35.6525 37.3321C35.1901 36.8412 35.1806 36.0781 35.6319 35.5777C36.0942 35.1043 36.851 35.0948 37.3245 35.5571C37.3273 35.559 37.3295 35.5609 37.3319 35.5631C37.3335 35.5646 37.3352 35.5663 37.3371 35.5682L40.29 38.5227L42.977 35.8342C43.4599 35.3735 44.2215 35.3782 44.6996 35.8453C44.7851 35.9308 44.858 36.0274 44.9134 36.1351C45.1873 36.6116 45.1081 37.2101 44.7202 37.5996L42.0444 40.2739L44.9545 43.1856C45.4454 43.6496 45.4644 44.4238 44.9989 44.9131C44.9953 44.9185 44.9906 44.9228 44.9859 44.9274C44.9822 44.9308 44.9785 44.9343 44.9751 44.9384Z",
    fill: "#AD0013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.cf60389af399e242ae8d33ad1ed6ef65.svg";
export { ForwardRef as ReactComponent };